import { isEmpty, flatten } from 'lodash';

export function getZones(data) {
	const zones = [];

	if (!isEmpty(data)) {
		const objectArray = Object.entries(data);
		objectArray.forEach(([key]) => {
			zones.push({
				label: key,
				value: key,
				id: key,
				states: Object.keys(data?.[key]),
			});
		});
	}

	return zones;
}

export function getStates(locations = {}, zones = []) {
	let states = [];
	const statesNew = [];

	console.log('locations', locations);
	console.log('zones', zones);

	if (!isEmpty(locations) && !isEmpty(zones)) {
		zones?.forEach((item) => {
			if (locations?.[item]) {
				const singleState = Object.keys(locations?.[item]);
				states.push([...singleState]);
			}
		});
		states = flatten(states);
		states.forEach((key) => {
			statesNew.push({
				label: key,
				value: key,
				id: key,
			});
		});
	}
	return statesNew;
}

export function getCities(statesWithCites = {}, states = []) {
	let cites = [];
	const citesNew = [];

	if (!isEmpty(statesWithCites) && states) {
		states.forEach((state) => {
			cites.push(statesWithCites?.[state]);
		});
		cites = flatten(cites);
		cites.forEach((key) => {
			citesNew.push({
				label: key,
				value: key,
				id: key,
			});
		});
	}
	return citesNew;
}

export function getStatesWithCities(response) {
	const states = {};
	Object.keys(response?.data)?.forEach((item) => {
		Object.keys(response?.data?.[item])?.forEach((state) => {
			states[state] = response?.data?.[item]?.[state];
		});
		return {
			label: item,
			value: item,
			id: item,
		};
	});
	return states;
}

export function getOnlyCities(response) {
	let cities = [];
	Object.keys(response?.data)?.forEach((item) => {
		Object.keys(response?.data?.[item])?.forEach((state) => {
			cities.push(response?.data?.[item]?.[state]);
		});
	});
	cities = flatten(cities);
	cities = cities?.map((item) => ({
		label: item,
		value: item,
		id: item,
	}));
	return cities;
}
